import api from './authService';

export const subscriptionPlansService = {
  async getPlans(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await api.get(`/subscription-plans?${queryString}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch subscription plans' };
    }
  },

  async getPlan(id) {
    try {
      const response = await api.get(`/subscription-plans/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch subscription plan' };
    }
  },

  async createPlan(planData) {
    try {
      const response = await api.post('/subscription-plans', planData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create subscription plan' };
    }
  },

  async updatePlan(id, planData) {
    try {
      const response = await api.put(`/subscription-plans/${id}`, planData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update subscription plan' };
    }
  },

  async togglePlanStatus(id) {
    try {
      const response = await api.patch(`/subscription-plans/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to toggle subscription plan status' };
    }
  },

  async deletePlan(id) {
    try {
      const response = await api.delete(`/subscription-plans/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete subscription plan' };
    }
  },

  async bulkAction(action, planIds) {
    try {
      const response = await api.post('/subscription-plans/bulk-action', {
        action,
        planIds
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to perform bulk action' };
    }
  },

  async syncPlanWithRazorpay(id) {
    try {
      const response = await api.post(`/subscription-plans/${id}/sync-razorpay`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to sync plan with Razorpay' };
    }
  },

  async syncAllPlansWithRazorpay() {
    try {
      const response = await api.post('/subscription-plans/sync-all-razorpay');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to sync all plans with Razorpay' };
    }
  },

  // ─── Coupons ──────────────────────────────────────────────────────────────
  async listAllCoupons() {
    try {
      const response = await api.get('/subscription-plans/coupons/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to list coupons' };
    }
  },

  async createCoupon(planId, payload) {
    try {
      const response = await api.post(`/subscription-plans/${planId}/coupons`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create coupon' };
    }
  },

  async updateCoupon(planId, couponId, payload) {
    try {
      const response = await api.put(`/subscription-plans/${planId}/coupons/${couponId}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update coupon' };
    }
  },

  async deleteCoupon(planId, couponId) {
    try {
      const response = await api.delete(`/subscription-plans/${planId}/coupons/${couponId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete coupon' };
    }
  },
};
